import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { Routes } from '@angular/router';
import { EmailConfirmComponent } from './email-confirm/email-confirm.component';

const routes: Routes = [
    {
        path: 'email-validation',
        component: EmailConfirmComponent

    },
    {
        path: '',
        component: ForgotPasswordComponent
    }

];

const COMPONENTS = [ForgotPasswordComponent, EmailConfirmComponent];
@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule.forChild(routes), HttpClientModule],
    exports: COMPONENTS,
    declarations: COMPONENTS
})
export class CandidateToolDataLayerModule {}
